"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const onlyAvailableAtHotmartClub_1 = __importDefault(require("components/onlyAvailableAtHotmartClub"));
const translate_1 = require("components/translate");
const Settings_1 = __importDefault(require("configs/Settings"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const community_1 = require("modules/app/services/datahub/community");
const UserStore_1 = __importDefault(require("modules/user/UserStore"));
const cta_communities_svg_1 = require("./images/cta-communities.svg");
const ctaCommunities_module_scss_1 = __importDefault(require("./ctaCommunities.module.scss"));
const CtaCommunities = ({ t, shortLocale }) => {
    const { marketplaceId: userId } = UserStore_1.default;
    const getUrlToNewClub = `${Settings_1.default.app.bw}/membership/list`;
    const getUrlAboutMore = (shortLocale) => {
        let locale = 'en';
        if (shortLocale === 'pt') {
            locale = 'pt-BR';
        }
        if (shortLocale === 'es') {
            locale = 'es';
        }
        return `${Settings_1.default.app.helpCenter}/${locale}/article/como-criar-uma-comunidade-no-hotmart-club/8805214381069`;
    };
    const handleRedirectToNewClubClick = () => {
        community_1.DatahubCommunityService.sendRedirectToNewClubEvent(userId);
    };
    const handleAboutMoreClick = () => {
        community_1.DatahubCommunityService.sendAboutMoreEvent(userId);
    };
    (0, react_1.useEffect)(() => {
        community_1.DatahubCommunityService.sendOpenPageEvent(userId);
    }, [userId]);
    return ((0, jsx_runtime_1.jsxs)("section", { className: "grid grid__transparent grid__block grid__noborder content__base__page content-list content__grid", children: [(0, jsx_runtime_1.jsx)("h1", { className: "_text-gray-800 _mb-6", children: t('general.communities') }), (0, jsx_runtime_1.jsxs)("div", { className: "_mt-7 _d-flex _flex-column _align-items-center _text-gray-500", children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(ctaCommunities_module_scss_1.default.container, '_d-flex _flex-column _align-items-center cta-container'), children: [(0, jsx_runtime_1.jsx)(cta_communities_svg_1.ReactComponent, { "aria-hidden": true }), (0, jsx_runtime_1.jsx)("span", { className: "_text-4 _mt-5 _mb-2 _text-center", children: t('cta_communities.subtitle') }), (0, jsx_runtime_1.jsx)("p", { className: "_text-2 _m-0 _text-center", children: t('cta_communities.content') }), (0, jsx_runtime_1.jsx)(onlyAvailableAtHotmartClub_1.default, {})] }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center _flex-column _flex-md-row _justify-content-end", children: [(0, jsx_runtime_1.jsxs)("a", { onClick: handleAboutMoreClick, target: "_blank", rel: "noreferrer", href: getUrlAboutMore(shortLocale), className: "hot-button hot-button--secondary _text-decoration-none _d-flex _align-items-center _mr-md-4 _mb-4 _mb-md-0", children: [(0, jsx_runtime_1.jsx)("span", { className: "_mr-4", children: t('cta_communities.know_more') }), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'arrow-up-right-from-square'] })] }), (0, jsx_runtime_1.jsx)("a", { onClick: handleRedirectToNewClubClick, target: "_blank", rel: "noreferrer", href: getUrlToNewClub, className: "hot-button hot-button--primary _text-decoration-none _d-flex _align-items-center _mb-4 _mb-md-0", children: (0, jsx_runtime_1.jsx)("span", { children: t('cta_communities.go_to_community') }) })] })] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    shortLocale: stores.UserStore.shortLocale
})))(CtaCommunities);
